import { render, staticRenderFns } from "./stockdividends.vue?vue&type=template&id=1d38c6a6&scoped=true"
import script from "./stockdividends.vue?vue&type=script&lang=js"
export * from "./stockdividends.vue?vue&type=script&lang=js"
import style0 from "./stockdividends.vue?vue&type=style&index=0&id=1d38c6a6&prod&lang=scss&scoped=true"
import style1 from "./stockdividends.vue?vue&type=style&index=1&id=1d38c6a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d38c6a6",
  null
  
)

export default component.exports